export default "__VITE_ASSET__BElrk3Jw__"